import vue from 'vue'
import Vuex from 'vuex'
vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageTitle: '首页',
    subPageTitle: '',
    menuIndex: '/home',
    myData: [],
    auth: '', // 用户权限
    uid: '', // 用户ID
    appID: '', // 每个APPid
    uname: '', // 用户名
    umobile: '', // 用户电话
    DMFSession: '', //DMFSessionToken
    appAuTh: [] // app 权限
  },
  mutations: {
    setPageTitle(state, data) {
      state.pageTitle = data;
    },
    setSubPageTitle(state, data) {
      state.setSubPageTitle = data;
    },
    setMenuIndex(state, data) {
      state.menuIndex = data;
    },
    increment (state, data) {
      state.myData.push(data)
    },
    modification (state, data) {
      state.auth = data
    },
    myAppID (state, data) {
      state.appID = data
    },
    myUid (state, data) {
      state.uid = data
    },
    myUname (state, data) {
      state.uname = data
    },
    myUmobile (state, data) {
      state.umobile = data
    },
    setAppAuth (state, data) {
      state.appAuTh.push(data)
    },
    setDMFSession (state, data) {
      state.DMFSession = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js